// @flow
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape } from 'react-intl';

import ProductSelectionTiles from './product-selection-tiles/ProductSelectionTilesComponent';
import type { ProductSelectionTilesProps } from './product-selection-tiles/ProductSelectionTilesComponent';

import './ProductSelection.scss';

/**
 * Page for selecting a product type for the Creation Flow
 */
const ProductSelectionComponent = (props: ProductSelectionTilesProps) => (
  <div className="product-selection-component">
    <div className="product-selection-component__title u-fontFamily-primaryMedium">
      <FormattedMessage id="app.creation.selectProductType.title" defaultMessage="What would you like to create?" />
    </div>
    <ProductSelectionTiles config={props.config} creationCategory={props.creationCategory} />
  </div>
);

ProductSelectionComponent.displayName = 'ProductSelection';

ProductSelectionComponent.propTypes = {
  config: ProductSelectionTiles.propTypes.config,
  creationCategory: PropTypes.string.isRequired,
};

ProductSelectionComponent.contextTypes = {
  intl: intlShape.isRequired,
};

export default ProductSelectionComponent;
